/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import ComplexTextInput from '../ComplexTextInput';
import ErrorMessage from '../ErrorMessage';
import ImageContainer from '../../inputs/ImageContainer'
import Select from '../Select';
import DateAndTime from '../DateAndTime';
import FormCheckbox from '../FormCheckbox';
import Switch from '../Switch';
import useStyles from './styles'

const FormStandardInput = props => {
  const { t } = useTranslation(['translation'])
  const classes = useStyles()
  const { type, id } = props;
  let Component;
  let translations = {};
  if (type === 'image') {
    Component = ImageContainer;
    translations.title = t(props.title) || t('COMMON.IMAGE_UPLOADER.TITLE');
    translations.text = t(props.text) || t('COMMON.IMAGE_UPLOADER.TEXT');
    translations.hint = t(props.hint) || t('COMMON.IMAGE_UPLOADER.HINT');
  } else if (type === 'select') {
    Component = Select;
    translations.title = t(props.title);
    translations.options = props.options.map((opt) => ({ label: t(opt.label), value: opt.value }));
    translations.noOptionsMessage = t(props.noOptionsMessage);
  } else if (type === 'dateandtime') {
    Component = DateAndTime;
    translations.dateTitle = t(props.dateTitle);
    translations.timeTitle = t(props.timeTitle);
  } else if (type === 'checkbox') {
    Component = FormCheckbox;
    translations.title = t(props.title);
  } else if (type === 'switch') {
    Component = Switch;
    translations.title = t(props.title);
  } else {
    Component = ComplexTextInput;
    translations.title = t(props.title);
  }

  return (
    <FormGroup
      style={{ marginBottom: props.marginBottom }}
      className={ type === 'image' ? classes.imageFormGroup : classes.formGroup }
    >
      <Component {...props} {...translations} />
      <ErrorMessage id={id} />
    </FormGroup>
  );
};


FormStandardInput.defaultProps = {
  type: 'text',
};

FormStandardInput.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string,
};

export default FormStandardInput;
